
import { WarningOutlined } from '@ant-design/icons';
import { formatShiftDateTime } from '../scheduleHelpers';
import OntraccrTag from '../../common/OntraccrTag';
import { Popover, Typography } from 'antd';
import colors from '../../constants/Colors';
import PropTypes from 'prop-types';
const { Text } = Typography;

const styles = {
  container: {
    maxWidth: 400,
    maxHeight: 300,
    overflowY: 'auto',
  },
  conflictCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 12,
    borderColor: colors.GRAY_300,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 12,
    padding: 12,
  },
  tagContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
  },
};

function ConflictPopoverContent({ conflicts }) {
  return (
    <div style={styles.container}>
      {conflicts.map(({
        id,
        title,
        startTime,
        endTime,
        isDraft,
        categoryName,
        categoryColor,
        projectName,
      }) => (
        <div key={id} style={styles.conflictCard}>
          <Text strong>
            {title}
          </Text>
          {(isDraft || categoryName) && (
            <div style={styles.tagContainer}>
              {isDraft && (
                <OntraccrTag color="orange">
                  Draft
                </OntraccrTag>
              )}
              {categoryName && (
                <OntraccrTag color={categoryColor} needsBorder>
                  {categoryName}
                </OntraccrTag>
              )}
            </div>
          )}
          {projectName && (
            <Text>Project:{' '}
              <Text type="secondary">{projectName}</Text>
            </Text>
          )}
          <Text type="secondary">
            {formatShiftDateTime(startTime, endTime)}
          </Text>
        </div>
      ))}
    </div>
  );
}

ConflictPopoverContent.propTypes = {
  conflicts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    isDraft: PropTypes.bool,
    categoryName: PropTypes.string,
    categoryColor: PropTypes.string,
    projectName: PropTypes.string,
  })).isRequired,
};
  
export default function ConflictWarningIcon({ conflicts }) {
  if (!conflicts?.length) return null;

  return (
    <Popover
      trigger="hover"
      title="Conflicting shifts"
      content={<ConflictPopoverContent conflicts={conflicts} />}
      getPopupContainer={() => document.body}
      // Above ant Select dropdown (z-index 1050)
      zIndex={1050}
    >
      <WarningOutlined
        style={{
          color: colors.ONTRACCR_ERROR,
          marginLeft: 4,
          cursor: 'pointer',
          flexShrink: 0,
        }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      />
    </Popover>
  );
}

ConflictWarningIcon.propTypes = {
  conflicts: PropTypes.arrayOf(PropTypes.shape({})),
};

ConflictWarningIcon.defaultProps = {
  conflicts: [],
};
